import { useUserController } from "@/base/controller/user-controller";
import { queryClient } from "@/base/libs/react-query";
import { scanApi } from "@/service/client";
import { ScanRequest } from "@/shared/model/scan_request.model";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "next/navigation";

export const useScanController = () => {
  const { user } = useUserController();

  const { data: scanRequestList } = useQuery({
    queryKey: ["scanRequest"],
    queryFn: () => scanApi.list(),
    enabled: !!user?._id,
  });

  const { id: idScanRequest } = useParams();

  const { data: scanResponseList } = useQuery({
    enabled: !!idScanRequest,
    queryKey: ["scanResponse", idScanRequest],
    queryFn: () => scanApi.scanResponse(idScanRequest as string),
  });

  const scanRequest = scanRequestList?.find(
    (scanRequest) => scanRequest._id === idScanRequest
  );

  const createScanRequest = async ({
    website,
    keyword_list,
  }: {
    website: string;
    keyword_list: string[];
  }): Promise<ScanRequest> => {
    const scanRequest = await scanApi.create({
      website,
      keyword_list,
    });

    queryClient.invalidateQueries({ queryKey: ["scanRequest"] });

    return scanRequest;
  };

  const deleteScanRequest = async (id_scan_request: string) => {
    await scanApi.delete(id_scan_request);
    queryClient.invalidateQueries({ queryKey: ["scanRequest"] });
  };

  const process = async (id_scan_request: string) => {
    await scanApi.process(id_scan_request);
    queryClient.invalidateQueries({ queryKey: ["scanRequest"] });
    queryClient.invalidateQueries({
      queryKey: ["scanResponse", id_scan_request],
    });
  };

  return {
    scanRequest,
    scanRequestList,
    createScanRequest,
    deleteScanRequest,
    process,
    scanResponseList,
  };
};
